<template>
  <div class="Login pt-0">
    <v-row class="mainContent">
      <v-col
        class="contentLeft pa-sm-0"
        sm="6"
        cols="12"
      >
        <v-col
          offset-sm="2"
          offset="1"
          class="my-11"
          lg="8"
          sm="10"
          cols="10"
        >
          <div class="headerLogo">
            <v-img
              :src="'./assets/logos/Amundi-Immo.svg'"
              class="logo-login"
              height="27"
              width="185"
            />
          </div>
          <h1 class="headerTitle my-6 my-lg-11">{{ $t('login.title') }}</h1>
          <div class="loginDescription mb-6 mb-lg-11 pr-10">{{ $t('login.description') }}</div>
          <div class="loginForm">
            <v-form ref="form">
              <v-col
                cols="12"
                md="6"
                sm="8"
                class="mb-4 mb-lg-5"
                style="padding: unset;"
              >
                <div class="inputLabel">{{ $t('login.e-mail') }}</div>
                <TextInput
                  v-model="credentials.username"
                  required
                  :placeholder="$t('login.e-mail')"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="8"
                style="padding: unset;"
              >
                <div class="inputLabel">{{ $t('login.password') }}</div>
                <TextInput
                  v-model="credentials.password"
                  required
                  :placeholder="$t('login.password')"
                  type="password"
                />
              </v-col>
            </v-form>
            <v-btn
              class=" white--text loginSubmit"
              color="primary"
              elevation="1"
              @click="submit"
            >
              {{ $t('login.connexion') }}
              <v-icon
                right
                dark
              >
                mdi-arrow-right
              </v-icon>
            </v-btn>
            <div class="forgottenPass">
              {{ $t('login.forgotten_password') }}
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          class="copyRight"
          align="center"
          justify="center"
        >
          <div>{{ $t('login.copy_right') }}</div>
          <v-img
            :src="'./assets/icons/WeSave-Conseil-logo-watermark@3x.svg'"
            class="logo-login"
            height="13"
            width="48"
          />
        </v-col>
      </v-col>
      <v-col
        sm="6"
        class="contentRight pa-0 d-none d-sm-flex"
      >
        <v-img
          height="auto"
          width="100%"
          cover
          :src="imgsrc('backgrounds', 'welcome-image.jpg')"
          class="backgroundsLogin"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import ApiService from '@/services/ApiService'
  import CommonMixin from '@/mixins/store/CommonMixin'
  import mixinDynImage from '@/mixins/utils/dynImage.js'
  import TextInput from '@/components/ui/inputs/TextInput'
  import { GRANT_TYPE } from '@/services/ApiService.const'

  export default {
    components: {
      TextInput,
    },
    mixins: [CommonMixin, mixinDynImage,],
    data() {
      return {
        credentials: {
          password: '',
          username: '',
        },
      }
    },
    methods: {
      async submit() {
        localStorage.setItem('advisor_mail', this.credentials.username)
        this.toggleAppLoader(true)
        const result = await ApiService.connect(
          GRANT_TYPE.password,
          this.credentials.username,
          this.credentials.password
        )
        this.toggleAppLoader(false)
        if (result.access_token) {
          this.$message({
            type: 'success',
            text: 'auth_success',
          })
          this.loadAdmin()
        } else {
          this.$message({
            type: 'error',
            text: 'auth_error',
          })
        }
      },
      async loadAdmin() {
        this.toggleAppLoader(true)
        this.$store.commit('profile/setCurrentRole', 'ADMIN')
        this.$store.commit('profile/setCurrentUser', {
          id: 0,
        })
        const config = await ApiService.getConfiguration()
        if (config) {
          this.$store.commit('common/setCurrentConfig', config.data)
          this.$store.commit('common/setEnumsOptions', {
            enums: config.data.enums,
            $t: this.$t.bind(this),
          })
        }
        this.$router.push({ name: 'UsersList', })
        this.toggleAppLoader(false)
      },
    },
  }
</script>

<style scoped lang="scss">
.Login {
  height: 100%;
  background-color: $color-ffffff;
  cursor: pointer;
  overflow: hidden;
  .mainContent {
    height: 100%;
    .contentLeft {
      position: relative;
      .headerTitle {
        letter-spacing: 0;
        font-size: 3.5rem;
        color: $color-000000;
        font-weight: bold;
        line-height: 1.4em;
        @media (max-width: 1025px) {
          font-size: 2rem;
        }
      }
      .loginDescription {
        font-size: 1.4em;
        color: $color-4d4d4f;
        line-height: 1.6em;
        @media (max-width: 1025px) {
          font-size: 1rem;
        }
      }
      .inputLabel {
        font-size: 0.8em;
        font-weight: 500;
        color: $color-102d69;
        letter-spacing: 0;
        line-height: 2em;
      }
      .inputField {
        padding-top: 0;
        font-size: 1em;
        width: 280px;
      }
      .v-text-field--outlined fieldset {
        color: $color-102d69 !important;
      }
      .loginSubmit {
        height: 48px;
        width: 165px;
        font-size: 1em;
        text-transform: capitalize;
        background-color: $color-009ee0 !important;
        box-shadow: 0 4px 8px 0 rgba(31, 54, 139, 0.08) !important;
        border-radius: 8px;
        margin-top: 2.5em;
        @media (max-width: 1025px) {
          margin-top: 1.5em;
        }
      }
      .forgottenPass {
        margin-top: 6em;
        color: $color-009ee0;
        font-size: 0.8em;
        font-weight: 500;
        letter-spacing: 0.32px;
        line-height: 1.3em;
        text-transform: uppercase;
        @media (max-width: 1025px) {
          margin-top: 4em;
        }
      }
      .copyRight {
        div {
          color: $color-b4bad2;
          font-size: 0.8em;
          font-weight: 500;
          letter-spacing: 0.18px;
          line-height: 1em;
          text-align: center;
        }
      }
    }
    .contentRight {
      background-color: $color-ffffff;
      height: auto;
    }
    .v-input {
      &.v-input--is-focused .v-input__control .v-input__slot fieldset {
        border-color: $color-727efd !important;
      }
    }

    .v-text-field--outlined >>> fieldset {
      border-color: $color-727efd;
    }
  }
}
</style>
